import { defineStore } from 'pinia';

export const useMainStore = defineStore('main', {
	state: () => ({
		breakpoints: {},
	}),
	getters: {},
	actions: {
		setBreakpoint(key, value) {
			this.breakpoints[key] = value;
		},
	},
});
